const id_mitra_list = {
    "": "Daftar Mitra",

    product: {
        btn_share: 'bagikan',
        btn_hide: 'sembunyikan',
        btn_share_all: 'bagikan semua',
        btn_hide_all: 'sembunyikan semua',
        search: 'Cari Nama Barang / SKU',
    },

    tag: {
        add: 'tambah tag',
        name: 'nama tag',
    },

    error: {
        tag: 'Tag wajib diisi',
        create_tag: 'Gagal membuat tag',
        create_own_product_share: 'Gagal membagikan barang',
        create_own_product_hide: 'Gagal menyembunyikan barang',
    },

    success: {
        create_tag: 'Berhasil membuat tag',
        create_own_product_share: 'Berhasil membagikan barang',
        create_own_product_hide: 'Berhasil menyembunyikan barang',
    },
}

export default id_mitra_list;